import { t } from 'i18next';

const Article = () => {
  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5">
          <div className="col-lg-5 wow fadeIn" data-wow-delay="0.1s">
            <img className="img-fluid" src="img/Co-logos/logo.png" alt="" />
          </div>
          <div className="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
            <div className="section-title">
              <p className="fs-5 fw-medium fst-italic text-primary">{t('about_us')}</p>
              <h1 className="display-6">{t('company_success_story')}</h1>
            </div>
            <p className="mb-4">{t('company_description')}</p>
            <a href="" className="btn btn-primary rounded-pill py-3 px-5">{t('read_more')}</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Article;